import React from "react";
import { PropTypes } from "prop-types";

const Card = ({ title, text, bg, imgSRC, url, children }) => (
  <div
    className="card"
    style={{
      border: 0,
      background: bg ? bg : `url(${imgSRC}) center center no-repeat`,
      backgroundSize: "cover",
      overflow: "hidden"
    }}
  >
    {
      <img
        src={imgSRC}
        className="card-img-top d-block"
        alt=""
        style={{
          width: `${bg ? "50%" : "100%"}`,
          height: "50%",
          margin: "2em auto",
          visibility: `${!bg ? "hidden" : "visible"}`
        }}
      />
    }

    <div className="card-body">
      <h5 className="card-title">{title}</h5>
      <p className="card-text txt-light-gray mt-5 mb-5">{text}</p>
      <div className="row align-items-center pr-3 pl-3">
        <div className="col d-md-flex order-md-2 justify-content-end mb-3 mb-md-0 text-center">
          {children}
        </div>
        <div className="col-12 col-md order-md-1">
          <a href={url} className="btn btn-primary d-block d-md-inline">
            Deploy
          </a>
        </div>
      </div>
    </div>
  </div>
);

Card.propTypes = {
  title: PropTypes.string.isRequired,
  text: PropTypes.string.isRequired,
  bg: PropTypes.string,
  imgSRC: PropTypes.string.isRequired,
  url: PropTypes.string.isRequired
};

export { Card };
